const Bnb = () => (
  <svg fill='none' viewBox='0 0 25 24'>
    <path
      fill='#F3BA2F'
      d='M12.284 24c6.627 0 12-5.373 12-12s-5.373-12-12-12c-6.628 0-12 5.373-12 12s5.372 12 12 12Z'
    />
    <path
      fill='#fff'
      d='m9.176 10.723 3.107-3.106 3.109 3.109L17.2 8.917 12.283 4 7.367 8.916l1.809 1.807Zm-3.085-.53 1.807 1.806-1.807 1.807L4.284 12l1.807-1.807Zm3.085 3.084 3.107 3.107 3.109-3.108 1.808 1.806L12.283 20l-4.916-4.915-.002-.002 1.81-1.806Zm11.108-1.278-1.807 1.809L16.668 12l1.807-1.807 1.809 1.805Z'
    />
    <path
      fill='#fff'
      d='m14.12 12-1.836-1.836-1.356 1.356-.155.156-.322.32-.003.003.003.004 1.833 1.833L14.12 12v-.002Z'
    />
  </svg>
)

export { Bnb }
